import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "Who is this consultation for?",
    a: "The consultation is intended for parents seeking personalized Ayurvedic guidance for children with concerns such as autism, ADHD, speech delay and other developmental concerns.",
  },
  {
    q: "Is this an online or in-person consultation?",
    a: "The USA visit offers limited in-person appointments. Availability and locations should be confirmed by the consultation team.",
  },
  {
    q: "How do I know which pathway to choose?",
    a: "Parents can select the pathway that best matches their needs. If you're unsure, select \"Not Sure — Please Guide Me\" and the consultation team can explain the available pathways.",
  },
  {
    q: "What is included in the $350 Samyak pathway?",
    a: "Samyak (Nadi Pariksha Consultation) includes an in-person pulse assessment, Vata–Pitta–Kapha analysis, a review of current imbalances and key concerns, personalized diet guidance, lifestyle and daily routine recommendations, and summary guidance notes.",
  },
  {
    q: "What is included in the $600 Medha pathway?",
    a: "Medha includes everything in the Samyak pathway, plus the 11 Brain Systems Assessment: a functional-pattern assessment across 11 brain systems, an Ayurvedic Brain Type explanation, detailed analysis of speech, attention, sensory processing, sleep, digestion, behavior, emotions and motivation, a personalized diet & lifestyle plan, and a comprehensive assessment report.",
  },
  {
    q: "What is included in the $1,000 Samanvaya program?",
    a: "Samanvaya includes everything in the Medha pathway, plus personalized Marma point selection, one-to-one parent training with Dr. Santhisree, practical demonstration and hands-on practice, guidance on locating and gently stimulating selected points, guidance on frequency, duration and precautions, a personalized home routine, and a detailed take-home protocol (PDF).",
  },
  {
    q: "Will my child need to be present?",
    a: "[To be confirmed based on the doctor's consultation protocol. Our team will clarify this when scheduling your appointment.]",
  },
  {
    q: "Can I bring previous medical or therapy reports?",
    a: "[To be confirmed based on the doctor's preference. Please mention any reports when our team contacts you.]",
  },
  {
    q: "Does this replace my child's existing medical or therapy care?",
    a: "No. The consultation is complementary and personalized. It is not a replacement for appropriate medical, developmental, therapeutic or emergency care. Please continue your child's existing care as advised by your licensed providers.",
  },
  {
    q: "How long is each consultation?",
    a: "[Consultation duration will be confirmed by our team when scheduling. Please mention any time constraints in your request.]",
  },
  {
    q: "Where in the USA will consultations take place?",
    a: "[Confirmed USA cities and venues will be announced shortly. Submit your details and our team will share availability for your preferred location.]",
  },
  {
    q: "How do I book?",
    a: "Submit the form on this page and the USA consultation team will contact you regarding availability and next steps.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#FAF7F2] py-16 lg:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <Eyebrow>
            <span className="mx-auto">Chapter 11 · Questions</span>
          </Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight">
            Frequently Asked Questions
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="bg-[#F4EFE6] border border-[#E5D3AD]/40 rounded-2xl px-6 overflow-hidden data-[state=open]:border-[#C5A059]"
              >
                <AccordionTrigger className="text-left font-serif text-lg text-[#1B3B2B] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#5C6E62] leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
